import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { images } from '../../assets';

const InitialLoader = () => {
  const [visible, setVisible] = useState(true);

  useEffect(() => {
    document.body.style.overflow = 'hidden';
    const timer = setTimeout(() => {
      setVisible(false);
      document.body.style.overflow = '';
      document.body.classList.add('layout-switch');
      const container = document.getElementById('ip-container');
      container?.classList.remove('loading');
      container?.classList.add('loaded');
    }, 700);
    return () => {
      clearTimeout(timer);
      document.body.style.overflow = '';
    };
  }, []);

  return (
    <AnimatePresence>
      {visible && (
        <motion.div
          className="apple-loader"
          initial={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          transition={{ duration: 0.55, ease: [0.22, 1, 0.36, 1] }}
        >
          <motion.img
            src={images.logo}
            alt="TheStudioVS"
            initial={{ opacity: 0, scale: 0.94 }}
            animate={{ opacity: 1, scale: 1 }}
            transition={{ duration: 0.7, ease: [0.22, 1, 0.36, 1] }}
          />
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default InitialLoader;
